import { Avatar, AvatarGroup, Box, Stack, Tooltip, Typography } from '@mui/material'
import { BuildOutlined } from '@mui/icons-material'
import { FabricationOrderCell } from '../DeliveryCells'

const avatarGroupStyle = {
  justifyContent: 'flex-end',
  '& .MuiAvatar-root': {
    width: 22,
    height: 22,
    fontSize: 10,
    bgcolor: 'grey.700',
    color: 'common.white',
    borderColor: theme => theme.palette.background.color_373636
  }
}

const initialsOf = (name) => String(name).split(' ').filter(Boolean).map((part) => part[0]).join('').slice(0, 2).toUpperCase()

const listOf = (value) => (Array.isArray(value) ? value : [])

/** The operators as initials; their names on hover. */
const OperatorsCell = ({ operators }) => {
  if (operators.length === 0) return ''
  return (
    <Tooltip title={operators.join(', ')}>
      <AvatarGroup max={3} sx={avatarGroupStyle}>
        {operators.map((operator) => <Avatar key={operator}>{initialsOf(operator)}</Avatar>)}
      </AvatarGroup>
    </Tooltip>
  )
}

// S176: the order in bold AND, for a forecast order, the amber "Forecast" chip (story 175, S116). The bold
// draws over the same cell the column declares, so the chip is not lost; the chip keeps its own weight.
const BoldFabricationOrder = ({ row }) => (
  <Box component='span' sx={{ fontWeight: 600, fontSize: '0.875rem', '& .MuiChip-root': { fontWeight: 400 } }}>
    <FabricationOrderCell row={row} />
  </Box>
)

/** The tools as a count; their references on hover. */
const ToolsCell = ({ tools }) => {
  if (tools.length === 0) return ''
  return (
    <Tooltip title={tools.join(' · ')}>
      <Stack direction='row' spacing={0.25} alignItems='center' sx={{ color: 'text.secondary', width: 'fit-content' }}>
        <BuildOutlined sx={{ fontSize: 16 }} />
        <Typography variant='caption'>{tools.length}</Typography>
      </Stack>
    </Tooltip>
  )
}

/**
 * How the panel draws some of the details columns, after the machine queue prototype. Every column
 * stays a column of its own, so sorting, filtering, the general search, TUNE and the CSV export are
 * the same as today; only the look of these cells changes.
 *
 * @param {Object} options
 * @param {Boolean} options.onMachineTab A machine's own tab: the machine column is not needed
 */
const buildPlannerDetailsCells = ({ onMachineTab }) => ({
  device: { hide: onMachineTab },
  fabricationOrder: { render: (row) => <BoldFabricationOrder row={row} /> },
  operators: { render: (row) => <OperatorsCell operators={listOf(row.operators)} /> },
  toolReferences: { render: (row) => <ToolsCell tools={listOf(row.toolReferences)} /> }
})

export default buildPlannerDetailsCells
